import React, { useEffect, useState } from 'react';
import { MemberHistory } from '../Services/allApi';

function Stepper() {
  const [count, setCount] = useState([1, 2, 3, 4, 5]);
  const [roles,setRoles]=useState([])
  const [AllDate,setAllDate]=useState([])

 useEffect(()=>{
  getMemberHistory()
 },[])

 const getMemberHistory=async()=>{
  const token = sessionStorage.getItem('access_token')
  const reqHeader = {
      "Content-Type": "application/json",
      "Authorization": `${token}`
  };
  const memberId=''
  const result=await MemberHistory(20,reqHeader)
  console.log(result);
  const newRoles=result?.data?.map((item)=>{
    return item?.role
  })
  console.log(newRoles);
  setRoles(newRoles)

  const newDates=result?.data?.map((item)=>{
    return item?.timestamp
  })
  console.log(newDates);
  setAllDate(newDates)
  
  
 }
  return (
    <div className="flex flex-col justify-center items-center w-full h-screen p-4">
      <div className="flex flex-col items-center space-y-4">
        {/* Top Labels */}
        <div className="flex flex-row items-center space-x-6 text-sm">
          {roles.map((item, index) => (
            <div key={index} className="flex items-center">
              <div className="text-center w-20">{item}</div>
            </div>
          ))}
        </div>

        {/* Step Indicators */}
        <div className="flex flex-row items-center">
          {count.map((item, index) => (
            <div key={index} className="flex items-center">
              <div className="w-6 h-6 bg-purple-300 rounded-full flex items-center justify-center text-white">{item}</div>
              {index < count.length - 1 && (
                <div className="w-20 h-1 bg-purple-300"></div> // Only render the line for all except the last step
              )}
            </div>
          ))}
        </div>

        {/* Bottom Labels */}
        <div className="flex flex-row items-center space-x-6 text-sm">
          {AllDate?.map((item, index) => (
            <div key={index} className="flex items-center">
              <div className="text-center w-20">{item?.slice(0,10)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Stepper;
